import { Component } from '../core/smpl-components.js'
import { Marquee } from '../modules/marquee.js'

// -------------------------------------------------------------------------- //
// Ticker — a continuous, seamless horizontal marquee of titles. Thin wrapper:
// all behaviour (GSAP loop, row cloning, resize rebuild, hover pause) lives in
// the reusable Marquee module. Root element needs the `.js-marquee-track` and
// `.js-marquee-row` hooks inside it.
// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {
		// Pass the CONTAINER (`.ticker`), not the row — Marquee looks up
		// `.js-marquee-track` and `.js-marquee-row` inside the element you give it.
		this.marquee = new Marquee(this.element, { speed: 100, pauseOnHover: true })
	}
	mount() {}
	unmount() {
		if (this.marquee) this.marquee.destroy()
	}
}
